import axios from 'axios'

import config from '../../config'
import {getDeviceId, getDeviceType} from "@crunchyroll/web-auth-utils";

const {
  deviceType,
  cookieDomain,
  accessToken,
  crApiUrl: baseURL,
  crEtpUrl,
  crApiAuthId,
  anonApiAuthId,
} = config

const API = axios.create({
  baseURL,
  withCredentials: true,
})

API.interceptors.request.use(
  (config) => {
    if (
      config.url === 'start_session.0.json' ||
      config.url === 'get_upsell_data.0.json'
    ) {
      config.params.sess_id = 1
      config.params.device_type = deviceType
      config.params.device_id = getDeviceId(cookieDomain)
      config.params.access_token = accessToken
      config.params.ui_device_type = getDeviceType()
      return config
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const AuthInstance = axios.create({
  baseURL: crEtpUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})

AuthInstance.interceptors.request.use(
  (config) => {
    if (config.getToken) {
      const tokenParams = new URLSearchParams()
      tokenParams.append('X-Tenant', 'cr')
      tokenParams.append('CloudFront-Viewer-Country', 'cloudfront-viewer-country')

      if (config.isLoggedToken) {
        tokenParams.append('grant_type', 'etp_rt_cookie')
      } else {
        tokenParams.append('grant_type', 'client_id')
      }

      tokenParams.append('device_id', getDeviceId(cookieDomain))
      tokenParams.append('device_type', getDeviceType())

      config.data = tokenParams
    }

    if (!config.headers) {
      config.headers = {};
    }

    if (config.isLoggedToken) {
      config.headers.Authorization = `Basic ${window.btoa(`${crApiAuthId}:`)}`
    } else {
      config.headers.Authorization = `Basic ${window.btoa(`${anonApiAuthId}:`)}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const EtpInstance = axios.create({
  baseURL: crEtpUrl,
  withCredentials: true,
})

EtpInstance.interceptors.request.use(
  (config) => {
    if (config.accessToken) {
      config.headers.Authorization = `Bearer ${config.accessToken}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export { API, AuthInstance, EtpInstance }
